import moment from 'moment';
import { DATA_LOADING_STATES } from '@config/Consts';

const setMetricsData = (state, status, data) => {
  state.metrics.dataStatus = status;
  if (status === DATA_LOADING_STATES.SUCCESS) {
    state.metrics.lastTimeDataUpdated = moment();
    state.metrics.value = data;
  }
};
const setMetricsTotalData = (state, status, data) => {
  state.metricsTotal.dataStatus = status;
  if (status === DATA_LOADING_STATES.SUCCESS) {
    state.metricsTotal.lastTimeDataUpdated = moment();
    state.metricsTotal.value = data;
  }
};
const setMetricsOverdueData = (state, status, data) => {
  state.metricsOverdue.dataStatus = status;
  if (status === DATA_LOADING_STATES.SUCCESS) {
    state.metricsOverdue.lastTimeDataUpdated = moment();
    state.metricsOverdue.value = data;
  }
};
const setAllMetricsStatus = (state, status) => {
  state.metrics.dataStatus = status;
  state.metricsTotal.dataStatus = status;
  state.metricsOverdue.dataStatus = status;
};

const setSkillsMetrics = (state, metricsData) => {
  if (metricsData) {
    setMetricsData(state, metricsData.metricsDataStatus, metricsData.skillsMetrics);
    setMetricsTotalData(state, metricsData.metricsTotalDataStatus,
      metricsData.skillMetricsTotal);
    setMetricsOverdueData(state, metricsData.metricsOverdueDataStatus,
      metricsData.skillMetricsOverdue);
  }
};

const setSort = (state, sort) => {
  state.sort = sort;
};

const setPresetValues = (state, preset) => {
  setSort(state, preset.sort);
};

export default {
  setMetricsData,
  setMetricsTotalData,
  setMetricsOverdueData,
  setSkillsMetrics,
  setAllMetricsStatus,
  setSort,
  setPresetValues,
};
